import { EventEmitter, Injectable } from '@angular/core';

import { LocalizationService } from './localization.service';

import { hubConnection, Options as SignalROptions } from 'signalr-no-jquery';
import { PlatformLocation } from '@angular/common';
import { DataHelper } from '../helpers/data.helper';

import { UiHelper } from '../helpers/ui.helper';

import { timer } from 'rxjs';

import { SocketURL } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SignalrServiceLegacy {
  connection: any;
  proxy: any;

  connectionEstablished: EventEmitter<any> = new EventEmitter();
  connectionExists = false;

  updateLiveFixture: EventEmitter<any> = new EventEmitter();
  updateLiveFixtureData: any;

  defaultSocketURL = '';

  constructor(private _LocalizationService: LocalizationService, private platformLocation: PlatformLocation, private _DataHelper: DataHelper, private _UIHelper: UiHelper) {
    // this.init();
  }

  init() {
    if (SocketURL == this.defaultSocketURL) this.connection = hubConnection((this.platformLocation as any).location.origin);
    else this.connection = hubConnection(SocketURL);

    this.proxy = this.connection.createHubProxy('liveBetsHub');

    this.connection.stateChanged((change: any) => {
      //0: 'connecting', 1: 'connected', 2: 'reconnecting', 4: 'disconnected'
      if (change.newState == 0) {
        //this._UIHelper.warningSnackBar("Connecting...",'');
        this.connectionExists = false;
      } else if (change.newState == 1) {
        //this._UIHelper.successSnackBar("Connected.",'');
        this.connectionExists = true;
        this.disposeSignalRTimer();
      } else if (change.newState == 2) {
        //this._UIHelper.warningSnackBar("Reconnecting...",'');
        this.connectionExists = false;
      } else if (change.newState == 4) {
        //this._UIHelper.errorSnackBar("Disconnected.",'');
        this.connectionExists = false;
        this.signalRTimer();
      }
      //////console.log("signal r",change);
      //SignalROptions.connectionState.d.reconnecting.connected
      /*if (change.newState === $.signalR.connectionState.reconnecting) {
          ////console.log("liveFeed is reconnecting!");
      }
      else if (change.newState === $.signalR.connectionState.connected) {
          ////console.log("liveFeed is connected!");
      }*/
    });

    this.registerOnServerEvents();
    this.startConnection();
  }

  public startConnection(): void {
    this.connection
      .start()
      .done((data: any) => {
        ////console.log('Now connected ' + data.transport.name + ', connection ID= ' + data.id);
        this.connectionExists = true;
        this.connectionEstablished.emit(true);

        this.proxy.invoke('AddGroup', this._LocalizationService.LANGID); //ok connected mış

        //////console.log("removeGroup", langId);
        //this.proxy.invoke('RemoveGroup', langId);
      })
      .fail((error: any) => {
        ////console.log('Could not connect ' + error);
        this.connectionEstablished.emit(false);
      });
  }

  public stopConnection(): void {
    this.connection.stop();
  }

  private registerOnServerEvents(): void {
    this.proxy.on('updateLiveFixture', (data: any) => {
      //////console.log('signal updateLiveFixture', data);
      this.updateLiveFixtureData = data;
      this.updateLiveFixture.emit(data);
      this._DataHelper.setLiveData(data);
      ////console.log(data);
      const a = data.map(i => i.BetStopReason).filter(i => i != undefined);
    });

    this.proxy.on('updateLiveEventDetail', (data: any) => {
      //////console.log('signal updateLiveEventDetail', data);
      this._DataHelper.setLiveEventDetailsData(data);
    });

    // Kırmızı Kart datası => GetTerminalLiveFixture içinde gönderiliyor artık ihtiyaç yok
    // BURASI CARD ile ilgili olabilir
    // this.proxy.on('updateCard',
    //   (data: any) => {
    //     //////console.log('signal card ', data);
    //     this._DataHelper.setCardData(data);
    //   });
  }

  public subscribeLiveEvent(_eventId: number): void {
    if (this.connectionExists) {
      this.proxy.invoke('SubscribeEvent', this._LocalizationService.LANGID, _eventId);
    }
  }

  public unSubscribeLiveEvent(_eventId: number): void {
    if (this.connectionExists) {
      try {
        console.warn('unSubscribeLiveEvent', _eventId);
        this.proxy.invoke('UnsubscribeEvent', this._LocalizationService.LANGID, _eventId);
      } catch (e) {
        console.error(e);
      }
    }
  }

  public readUpdatedEvents(): void {
    if (this.connectionExists) this.proxy.invoke('read', this._LocalizationService.LANGID);
  }

  sourceSignalr;
  _signalrWatch;
  public signalRTimer(): void {
    this.disposeSignalRTimer();
    this.sourceSignalr = timer(10000, 10000);
    this._signalrWatch = this.sourceSignalr.subscribe(val => {
      this.startConnection();
    });
  }

  public disposeSignalRTimer(): void {
    if (this._signalrWatch != undefined) {
      this._signalrWatch.unsubscribe();
      this._signalrWatch = null;
      this.sourceSignalr = null;
    }
  }
}
